export const SIZES = {
    M: 24,
    L: 32,
};

export const EVENTS_OPTIONS = {
    bubbles: true,
    composed: true,
    cancelable: false,
};
export const EVENT_INCREMENT = 'increment';
export const EVENT_DECREMENT = 'decrement';
